<app-navbar></app-navbar>
<flash-messages></flash-messages>
<div class="d-flex justify-content-center" id="contentHolder">
  <router-outlet></router-outlet>
</div>
